// API Configuration for different environments
const getApiBaseUrl = () => {
  if (import.meta.env.DEV) {
    // Development - use local backend
    return 'http://localhost:3001'
  } else {
    // Production - use Railway backend URL
    // This will be set via environment variable in Vercel
    return import.meta.env.VITE_API_URL || 'https://api.sourcedin.ai'
  }
}

export const API_BASE_URL = getApiBaseUrl()

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string) => {
  return `${API_BASE_URL}${endpoint}`
}

// Common API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    ME: '/api/auth/me',
    LINKEDIN_URL: '/api/auth/linkedin/url',
    LINKEDIN_CALLBACK: '/api/auth/linkedin/callback',
    RESET_PASSWORD_REQUEST: '/api/auth/reset-password-request',
    RESET_PASSWORD: '/api/auth/reset-password'
  },
  RFPS: {
    LIST: '/api/rfps',
    CREATE: '/api/rfps',
    DETAIL: (id: string) => `/api/rfps/${id}`,
    UPDATE: (id: string) => `/api/rfps/${id}`,
    DELETE: (id: string) => `/api/rfps/${id}`,
    PUBLIC: '/api/rfps',
    STATS: '/api/rfps/stats/overview'
  },
  RESPONSES: {
    CREATE: '/api/responses',
    LIST: '/api/responses',
    DETAIL: (id: string) => `/api/responses/${id}`,
    STATS: '/api/responses/stats/supplier',
    RECENT: '/api/responses/recent/supplier'
  },
  COMPANIES: {
    GET: (name: string) => `/api/companies/${encodeURIComponent(name)}`,
    CREATE: '/api/companies'
  },
  WATCHLIST: {
    ADD: '/api/watchlist',
    REMOVE: (id: string) => `/api/watchlist/${id}`,
    LIST: '/api/watchlist',
    CHECK_BATCH: '/api/watchlist/check-batch'
  },
  SUBSCRIPTION: {
    STATUS: '/api/subscription/status',
    PLANS: '/api/subscription/plans',
    CREATE_CHECKOUT: '/api/subscription/create-checkout-session',
    CANCEL: '/api/subscription/cancel'
  },
  AI: {
    GENERATE_RFP: '/api/ai/generate-rfp',
    GENERATE_RESPONSE: '/api/ai/generate-response',
    IMPROVE_RFP: '/api/ai/improve-rfp',
    IMPROVE_RESPONSE: '/api/ai/improve-response'
  }
}
